






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {TipoVeiculo} from '@/model/resource/TipoVeiculo'
import {InputTipoVeiculoSchema} from '@/schema/resource/TipoVeiculo/InputTipoVeiculoSchema'

@Component
export default class PersistTipoVeiculoView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputTipoVeiculoSchema()
  tipoVeiculo = new TipoVeiculo()

  async created() {
    await this.populate()
    if (this.tipoVeiculo.ativo == null) {
      this.tipoVeiculo.ativo = false
    }
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.tipoVeiculo.getTipoVeiculoById(id)
    }

    $.await.done('getTipoVeiculoById')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.tipoVeiculo.persist()
    await Helper.successAndPush('system.success.persist', '/tipo-veiculo/list')
  }
}
